var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.amostra)?_c('div',[(_vm.componentInfo)?_c(_vm.componentInfo,{tag:"component",attrs:{"amostra":_vm.amostra,"short":_vm.short}}):_c('span',{staticClass:"text--disabled"},[_vm._v("N/A")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }